<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="overflow-hidden">
    <div slot="no-body" class="card-wrap">
      <div class="p-6 pb-0" :class="{'flex justify-between flex-row-reverse items-center': iconRight,}">
        <feather-icon
          :icon="icon"
          class="p-3 inline-flex rounded-full"
          :class="[`text-${color}`, { 'mb-4': !iconRight }]"
          :style="{ background: `rgba(var(--vs-${color}),.15)` }"
        ></feather-icon>
        <div>
          <h3 class="mb-1 font-bold">{{ statistic }}</h3>
          <span>{{ statisticTitle }}</span>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    statistic: {
      type: [Number, String],
      required: true,
    },
    statisticTitle: {
      type: String,
    },
    color: {
      type: String,
      default: "primary",
    },
    type: {
      type: String,
      default: "line",
    },
    iconRight: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
};
</script>

<style lang="scss">
	.card-wrap{
		text-align: center;
		padding-bottom: 20px;
		min-width: 200px
	}
</style>
